/**
 * Product availability line (FND-803).
 *
 * Mirrors the selected variant's stock state, updating on the variant picker's
 * 'on:variant:change' event. The initial state is rendered server-side, so this
 * only handles changes.
 */
if (!customElements.get('product-availability')) {
  class ProductAvailability extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.status = this.querySelector('.js-availability');
      this.text = this.querySelector('.js-availability-text');

      const section = this.closest('.js-product') || this.closest('.product');
      const variantPicker = section && section.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    /**
     * Handles a variant change on the product form.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      // A combination with no matching variant is unavailable, not "in stock".
      const variant = evt.detail ? evt.detail.variant : null;
      this.setAvailable(Boolean(variant && variant.available));
    }

    /**
     * Updates the line to reflect a stock state.
     * @param {boolean} isAvailable - Whether the selected variant is available.
     */
    setAvailable(isAvailable) {
      if (!this.status || !this.text) return;

      this.dataset.available = String(isAvailable);
      this.status.classList.toggle('product-availability__status--out', !isAvailable);
      this.text.textContent = isAvailable
        ? this.dataset.textInStock
        : this.dataset.textOutOfStock;
    }
  }

  customElements.define('product-availability', ProductAvailability);
}
